import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY } from '@/hooks/api/use-category-queries';
import { PREDEFINED_MESSAGES_QUERY_KEY } from '@/hooks/api/use-predefined-message-queries';
import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

export function useDeletePredefinedMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      await httpClient.delete(API_ROUTES.predefinedMessages.detail(id));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY });
    },
  });
}
